import { render } from "./ProjectSmetaAgreementCompare.vue?vue&type=template&id=68bcb725&scoped=true"
import script from "./ProjectSmetaAgreementCompare.vue?vue&type=script&lang=js"
export * from "./ProjectSmetaAgreementCompare.vue?vue&type=script&lang=js"

import "./ProjectSmetaAgreementCompare.vue?vue&type=style&index=0&id=68bcb725&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bcb725"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QToggle,QIcon,QSpinner});
